import { Box, Typography } from "@mui/material";

interface Props {
  Actions: React.ReactNode;
}
const WorkbookReportsListActions = ({ Actions }: Props) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 2 }}>
      <Typography variant="h6">Workbook</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>{Actions}</Box>
    </Box>
  );
};

export default WorkbookReportsListActions;
